import {
  CarouselControls,
  CarouselNavigation,
  CarouselPagination,
  CarouselSlide,
  Carousel as DSCarousel,
} from '@cinch-labs/design-system'
import type { Vehicle } from '@cinch-nx/shared-types'
import cx from 'classnames'

import styles from './carousel.module.css'
import { VehicleCard } from '../cards/cards'

interface CarouselProps {
  carouselName: string
  vehicles: Vehicle[]
}

export const Carousel = ({ carouselName, vehicles }: CarouselProps) => {
  const navAriaLabels = {
    previous: 'Go to previous slide',
    next: 'Go to next slide',
  }

  return (
    <>
      <DSCarousel
        name={carouselName}
        swiperSettings={{
          slidesPerView: 1,
          spaceBetween: 16,
          breakpoints: {
            564: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          },
        }}
        ariaLabel={`${carouselName}-carousel`}
      >
        {vehicles.map(
          (vehicle) =>
            !vehicle.isReserved &&
            vehicle.isAvailable && (
              <CarouselSlide key={vehicle.vehicleId}>
                <VehicleCard vehicle={vehicle} carouselName="latest-cars" />
              </CarouselSlide>
            ),
        )}
      </DSCarousel>
      <CarouselControls customClassNames={styles.controlsWrapper}>
        <CarouselPagination
          name={carouselName}
          className={cx(
            `${carouselName}-pagination`,
            styles.pagination,
            styles.customPagination,
          )}
          data-testid="ds-carousel-pagination"
          aria-hidden="true"
        />
        <CarouselNavigation
          name={carouselName}
          ariaLabels={navAriaLabels}
          ariaHidden={true}
          customClassNames={{
            prevButton: styles.prevButton,
            nextButton: styles.nextButton,
          }}
        />
      </CarouselControls>
    </>
  )
}
